// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"791b836e","549":"15a69d76"}[chunkId] + ".chunk.css";
};